export const WIZARD_STEPS_ALL = ["empresa", "import", "perfil"];

export function computeIsCreator(user) {
  const userId = user?._id;
  const creadoPor = user?.empresa?.creadoPor;
  if (!userId || !creadoPor) return false;
  return String(creadoPor) === String(userId);
}

export function computeApplicableSteps(isCreator) {
  return isCreator ? WIZARD_STEPS_ALL : ["perfil"];
}
